module.exports = __webpack_public_path__ + "crm_static/img/sgif_bg1@3x.5e9bcde6.png";